<script setup lang="ts">
import { createModel } from '@/hooks/model';
import StringInput from '@/components/form/inputs/StringInput.vue';
import TextInput from '@/components/form/inputs/TextInput.vue';
import Button from '@/components/Button.vue';
import { ContactForm } from '@/forms/contact-form';
import { api } from '@/lib/api';
import { ref } from 'vue';
import { successToast } from '@/lib/toast';

const [model, newModel, destroyModel] = createModel(ContactForm)

const buttonElt = ref<any>(null)

const send = () => {
    const data: any = model.value?.data
    buttonElt.value.start()
    api().track().post("/send-form", { 'data': data }).then((response: any) => {
        successToast({
            title: `Your form has submitted successfuly`,
            closable: false,
        });
        buttonElt.value.stop()
    });
}

newModel()
</script>
<template>
    <div class="form-body">
        <form @submit.prevent="send" v-if="model">
            <div class="row">
                <div class="field col-12">
                    <StringInput noLabel :field="model?.fullName" :placeholder="model.fullName.label"></StringInput>
                </div>
                <div class="field col-12">
                    <StringInput noLabel :field="model?.email" :placeholder="model.email.label"></StringInput>
                </div>
                <div class="field col-12">
                    <StringInput noLabel :field="model?.phoneNumber" :placeholder="model.phoneNumber.label">
                    </StringInput>
                </div>
                <div class="field col-12">
                    <TextInput noLabel :field="model?.message" :placeholder="model.message.label"></TextInput>
                </div>
            </div>
            <Button ref="buttonElt" :text="'SEND MESSAGE'" :loading-text="'SENDING...'"></Button>
        </form>
    </div>
</template>